import { useState } from "react";
import { errorMessage } from "../../lib/api";
import { errorInfo } from "../../lib/collaborators";
import { toast } from "sonner";

export function useOrgMutation(refs) {
  const [busy, setBusy] = useState(false);
  const run = async (request, success, after) => {
    setBusy(true);
    try {
      const { data } = await request();
      toast.success(success);
      if (data?.warnings && data.warnings.visible_members !== undefined) {
        const w = data.warnings;
        toast.info(`Service désactivé : ${w.visible_members} personne${w.visible_members > 1 ? "s" : ""} déjà rattachée${w.visible_members > 1 ? "s" : ""} (visibles par vous)${w.others_hidden ? ", et d'autres hors de votre périmètre" : ""} restent rattachée${w.visible_members > 1 ? "s" : ""}.`);
      }
      await refs.reload();
      after?.();
      return true;
    } catch (error) {
      const info = errorInfo(error);
      toast.error(info.data?.msg || errorMessage(error));
      if (info.code === "version_conflict") await refs.reload();
      return false;
    } finally {
      setBusy(false);
    }
  };
  return { busy, run };
}
